"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Markdown = exports.MarkdownDefaultProps = exports.MarkdownFontSizes = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var lodash_1 = require("lodash");
var use_entities_1 = require("../../hooks/use-entities");
var link_1 = require("./link");
var markdown_to_jsx_1 = __importDefault(require("markdown-to-jsx"));
var entity_content_embed_1 = require("../entities/entity-content-embed");
var entity_latest_grid_1 = require("../entities/entity-latest-grid");
var link_value_1 = require("../entities/link-value");
var use_entity_1 = require("../../hooks/use-entity");
var field_placeholder_1 = require("./field-placeholder");
var react_medium_image_zoom_1 = __importDefault(require("react-medium-image-zoom"));
require("react-medium-image-zoom/dist/styles.css");
exports.MarkdownFontSizes = {
  small: 13,
  medium: 15,
  large: 18
};
exports.MarkdownDefaultProps = {
  showEmbeds: true,
  embeds: [],
  linkEmbeds: [],
  linkRichEmbeds: [],
  atEmbeds: [],
  entityTypeNameEmbedExclusions: [],
  useDivsForParagraphs: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    line-height: 1.6em;\n    ", "\n \n    img {\n      max-width: 100%;\n    }\n    \n    b, strong {\n      color: ", ";\n    }\n  "], ["\n    color: ", ";\n    line-height: 1.6em;\n    ", "\n \n    img {\n      max-width: 100%;\n    }\n    \n    b, strong {\n      color: ", ";\n    }\n  "])), theme_1.theme.COLOR('text'), function (_a) {
    var size = _a.size;
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-size: ", ";\n    "], ["\n      font-size: ", ";\n    "])), theme_1.theme.FONT_SIZE(exports.MarkdownFontSizes[size]));
  }, theme_1.theme.COLOR('dark'))
});
var LinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    color: ", ";\n    text-decoration: none;\n    font-weight: 500;\n  "], ["\n    color: ", ";\n    text-decoration: none;\n    font-weight: 500;\n  "])), theme_1.theme.COLOR('primary'))
});
var EmbedsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2))
});
var EmbedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n  "])), theme_1.theme.UNIT(3), theme_1.theme.UNIT(4))
});
var TagEmbedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    margin-top: ", ";\n\n    h1 {\n      margin-top: 0 !important;\n    }\n\n    ", "\n  "], ["\n    margin-top: ", ";\n\n    h1 {\n      margin-top: 0 !important;\n    }\n\n    ", "\n  "])), theme_1.theme.UNIT(6), function (props) {
    return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      img {\n        object-fit: ", ";\n      }\n    "], ["\n      img {\n        object-fit: ", ";\n      }\n    "])), props._imageFit);
  })
});
var ExternalEmbedStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    img {\n      background-color: #FFF;\n      object-fit: cover;\n    }\n\n    h1 {\n      margin-top: 0 !important;\n    }\n  "], ["\n    margin-top: ", ";\n    margin-bottom: ", ";\n\n    img {\n      background-color: #FFF;\n      object-fit: cover;\n    }\n\n    h1 {\n      margin-top: 0 !important;\n    }\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(5))
});
var LatestStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    a {\n      font-weight: 400;\n    }\n\n    h1 {\n      margin-top: 0 !important;\n    }\n\n\n    .entity-follow-controls {\n      ul, li {\n        list-style: none;\n        margin-bottom: 0;\n      }\n\n      ul {\n        padding: 0;\n      }\n\n      h5 {\n        margin-bottom: 0;\n        padding-left: ", ";\n        font-weight: 400;\n      }\n\n      li {\n        padding-left: 0;\n      }\n\n      li::before {\n        content: none;\n      }\n    }\n  "], ["\n    a {\n      font-weight: 400;\n    }\n\n    h1 {\n      margin-top: 0 !important;\n    }\n\n\n    .entity-follow-controls {\n      ul, li {\n        list-style: none;\n        margin-bottom: 0;\n      }\n\n      ul {\n        padding: 0;\n      }\n\n      h5 {\n        margin-bottom: 0;\n        padding-left: ", ";\n        font-weight: 400;\n      }\n\n      li {\n        padding-left: 0;\n      }\n\n      li::before {\n        content: none;\n      }\n    }\n  "])), theme_1.theme.UNIT(1))
});
var HStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-family: ", ";\n    color: ", ";\n    margin-bottom: 0.5em;\n    font-weight: 500;\n    line-height: 1.25em;\n  "], ["\n    font-family: ", ";\n    color: ", ";\n    margin-bottom: 0.5em;\n    font-weight: 500;\n    line-height: 1.25em;\n  "])), theme_1.theme.FONT('sans'), theme_1.theme.COLOR('dark'))
});
var H1Styles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    font-size: 1.25em;\n    margin-top: 1em;\n    padding-top: ", ";\n  "], ["\n    ", ";\n    ", ";\n    font-size: 1.25em;\n    margin-top: 1em;\n    padding-top: ", ";\n  "])), HStyles, theme_1.theme.H_DOT_BG(), theme_1.theme.UNIT(4))
});
var H2Styles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n    ", ";\n    ", ";\n    padding-bottom: 1em;\n    margin-bottom: 1em;\n    margin-top: 2em;\n    background-position: bottom left;\n    font-size: 1.15em;\n  "], ["\n    ", ";\n    ", ";\n    padding-bottom: 1em;\n    margin-bottom: 1em;\n    margin-top: 2em;\n    background-position: bottom left;\n    font-size: 1.15em;\n  "])), HStyles, theme_1.theme.DOT_BG('h'))
});
var H3Styles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    ", ";\n    margin-top: 2em;\n    font-size: 1.00em;\n  "], ["\n    ", ";\n    margin-top: 2em;\n    font-size: 1.00em;\n  "])), HStyles)
});
var H4Styles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n    ", ";\n    font-size: 1.0em;\n  "], ["\n    ", ";\n    font-size: 1.0em;\n  "])), HStyles)
});
var H5Styles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n    ", ";\n    font-size: 0.9em;\n  "], ["\n    ", ";\n    font-size: 0.9em;\n  "])), HStyles)
});
var H6Styles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    ", ";\n    font-size: 0.9em;\n  "], ["\n    ", ";\n    font-size: 0.9em;\n  "])), HStyles)
});
// --- Block Level Elements ---->
var BlockStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n    margin-top: 0;\n    margin-bottom: 1.0em;\n    font-size: 1em;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "], ["\n    margin-top: 0;\n    margin-bottom: 1.0em;\n    font-size: 1em;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  "])))
});
// ----- Lists ------->
var ListStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    ", ";\n\n    padding-left: 1em;\n    position: relative;\n    margin-bottom: 1.75em;\n\n    li {\n      position: relative;\n      padding-left: ", ";\n      margin-bottom: 0.5em;\n    }\n  "], ["\n    ", ";\n\n    padding-left: 1em;\n    position: relative;\n    margin-bottom: 1.75em;\n\n    li {\n      position: relative;\n      padding-left: ", ";\n      margin-bottom: 0.5em;\n    }\n  "])), BlockStyles, theme_1.theme.UNIT(1))
});
var OLStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n    ", ";\n    list-style: decimal;\n    margin-left: ", ";\n  "], ["\n    ", ";\n    list-style: decimal;\n    margin-left: ", ";\n  "])), ListStyles, theme_1.theme.UNIT(1))
});
var ULStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    ", ";\n    list-style: none;\n    margin-left: ", ";\n\n    /* Colored list bullets */\n\n    li::before {\n      color: ", ";\n      content: \"\u2022\";\n      font-size: 1.5em;\n      position: absolute;\n      left: -0.75em;\n      top: -2px;\n    }\n  "], ["\n    ", ";\n    list-style: none;\n    margin-left: ", ";\n\n    /* Colored list bullets */\n\n    li::before {\n      color: ", ";\n      content: \"\u2022\";\n      font-size: 1.5em;\n      position: absolute;\n      left: -0.75em;\n      top: -2px;\n    }\n  "])), ListStyles, theme_1.theme.UNIT(1), theme_1.theme.COLOR('primary'))
});
// ---- Paragraph ----->
var PStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), BlockStyles)
});
var TableStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n    border-collapse: collapse;\n    margin-bottom: ", ";\n\n    td, th {\n      padding: ", ";\n      border: 1px solid ", ";\n    }\n\n    th {\n      background-color: #EFEEEE;\n      font-weight: 600;\n      text-align: left;\n    }\n\n    thead th {\n      background-color: ", ";\n      font-weight: 500;\n    }\n\n  "], ["\n    border-collapse: collapse;\n    margin-bottom: ", ";\n\n    td, th {\n      padding: ", ";\n      border: 1px solid ", ";\n    }\n\n    th {\n      background-color: #EFEEEE;\n      font-weight: 600;\n      text-align: left;\n    }\n\n    thead th {\n      background-color: ", ";\n      font-weight: 500;\n    }\n\n  "])), theme_1.theme.UNIT(6), theme_1.theme.UNIT(2), theme_1.theme.COLOR('line-mid'), theme_1.theme.COLOR('app-chrome'))
});
var HRStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    border: none;\n    height: 2px;\n    ", ";\n  "], ["\n    border: none;\n    height: 2px;\n    ", ";\n  "])), theme_1.theme.H_DOT_BG('line-mid', 1.5))
});
var ZoomStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var ImgStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n    width: 100%;\n    max-width: 600px;\n    margin: ", " 0;\n  "], ["\n    width: 100%;\n    max-width: 600px;\n    margin: ", " 0;\n  "])), theme_1.theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_26 || (templateObject_26 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Link: (0, styled_components_1.default)(link_1.Link)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  Latest: (0, styled_components_1.default)(entity_latest_grid_1.EntityLatestGrid)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["", ""], ["", ""])), LatestStyles),
  Embeds: styled_components_1.default.div(templateObject_29 || (templateObject_29 = __makeTemplateObject(["", ""], ["", ""])), EmbedsStyles),
  Embed: (0, styled_components_1.default)(entity_content_embed_1.EntityContentEmbed)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["", ""], ["", ""])), EmbedStyles),
  TagEmbed: (0, styled_components_1.default)(entity_content_embed_1.EntityContentEmbed)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["", ""], ["", ""])), TagEmbedStyles),
  Image: styled_components_1.default.img(templateObject_32 || (templateObject_32 = __makeTemplateObject(["", ""], ["", ""])), ImgStyles),
  Zoom: (0, styled_components_1.default)(react_medium_image_zoom_1.default)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["", ""], ["", ""])), ZoomStyles),
  Table: styled_components_1.default.table(templateObject_34 || (templateObject_34 = __makeTemplateObject(["", ""], ["", ""])), TableStyles),
  H1: styled_components_1.default.h1(templateObject_35 || (templateObject_35 = __makeTemplateObject(["", ""], ["", ""])), H1Styles),
  H2: styled_components_1.default.h2(templateObject_36 || (templateObject_36 = __makeTemplateObject(["", ""], ["", ""])), H2Styles),
  H3: styled_components_1.default.h3(templateObject_37 || (templateObject_37 = __makeTemplateObject(["", ""], ["", ""])), H3Styles),
  H4: styled_components_1.default.h4(templateObject_38 || (templateObject_38 = __makeTemplateObject(["", ""], ["", ""])), H4Styles),
  H5: styled_components_1.default.h5(templateObject_39 || (templateObject_39 = __makeTemplateObject(["", ""], ["", ""])), H5Styles),
  H6: styled_components_1.default.h6(templateObject_40 || (templateObject_40 = __makeTemplateObject(["", ""], ["", ""])), H6Styles),
  HR: styled_components_1.default.hr(templateObject_41 || (templateObject_41 = __makeTemplateObject(["", ""], ["", ""])), HRStyles),
  UL: styled_components_1.default.ul(templateObject_42 || (templateObject_42 = __makeTemplateObject(["", ""], ["", ""])), ULStyles),
  OL: styled_components_1.default.ol(templateObject_43 || (templateObject_43 = __makeTemplateObject(["", ""], ["", ""])), OLStyles),
  P: styled_components_1.default.p(templateObject_44 || (templateObject_44 = __makeTemplateObject(["", ""], ["", ""])), PStyles),
  DIVP: styled_components_1.default.div(templateObject_45 || (templateObject_45 = __makeTemplateObject(["", ""], ["", ""])), PStyles)
};
var Markdown = function (props) {
  var className = props.className,
    size = props.size,
    entityTypeNameEmbedExclusions = props.entityTypeNameEmbedExclusions,
    showEmbeds = props.showEmbeds,
    text = props.text,
    useDivsForParagraphs = props.useDivsForParagraphs,
    _a = props.linkEmbeds,
    linkEmbeds = _a === void 0 ? [] : _a,
    atEmbeds = props.atEmbeds,
    embeds = props.embeds,
    _b = props.linkRichEmbeds,
    linkRichEmbeds = _b === void 0 ? [] : _b;
  var entity = (0, use_entity_1.useEntity)();
  var entities = (0, use_entities_1.useEntities)();
  var entitiesByPluralSlug = react_1.default.useMemo(function () {
    return (0, lodash_1.keyBy)(entities, 'pluralSlug');
  }, [entities]);
  var richEmbedByUrl = react_1.default.useMemo(function () {
    return new Map(linkRichEmbeds.map(function (e) {
      return [e.url, e];
    }));
  }, [linkRichEmbeds]);
  var overrides = {
    h1: My.H1,
    h2: My.H2,
    h3: My.H3,
    h4: My.H4,
    h5: My.H5,
    h6: My.H6,
    hr: My.HR,
    ol: My.OL,
    ul: My.UL,
    table: My.Table,
    p: {
      component: function (props) {
        if (useDivsForParagraphs) {
          return react_1.default.createElement(My.DIVP, __assign({}, props), props.children);
        }
        return react_1.default.createElement(My.P, __assign({}, props), props.children);
      }
    },
    Field: {
      component: function (props) {
        var children = props.children,
          name = props.name,
          type = props.type;
        return react_1.default.createElement(field_placeholder_1.FieldPlaceholder, {
          entityTypeLabel: entity === null || entity === void 0 ? void 0 : entity.name,
          fieldType: type,
          fieldName: name
        }, children);
      }
    },
    Latest: {
      component: function (props) {
        var _a = props.count,
          count = _a === void 0 ? 3 : _a,
          type = props.type;
        if (!type) {
          return null;
        }
        return react_1.default.createElement(My.Latest, {
          limit: 3,
          entityTypeName: type
        });
      }
    },
    a: {
      component: function (props) {
        var children = props.children;
        // check for an internal platform link. These are added via @mentions, or Markdown editor insertion
        var href = (0, lodash_1.isString)(props.href) ? props.href || '' : '';
        var matches = href.match && href.match(/^\/(?:platform\/)?([^\/]+)\/(.*)\/?/i);
        if (matches && matches.length > 2) {
          var entityTypePluralSlug = matches[1];
          var entitySlug = matches[2];
          // find an entity which matches the first sub-match on plural slug
          var defn = entitiesByPluralSlug[entityTypePluralSlug];
          if (defn) {
            return react_1.default.createElement(My.Link, {
              inline: true,
              inverted: true,
              to: defn.to(matches[2])
            }, children);
          }
        } else {
          var firstChild = (0, lodash_1.first)(props.children);
          // we don't want to replace standard markdown links with embeds as they exist in the flow of text)
          // when it's a standard link, the "children" is just the current href value for the link
          var isEmbeddableLink = firstChild === props.href;
          // console.log('isEmbeddableLink', firstChild, props.href, isEmbeddableLink);
          if (showEmbeds && isEmbeddableLink) {
            // this is an external link 
            var linkEmbed = linkEmbeds.find(function (linkEmbed) {
              return linkEmbed.url === href;
            });
            if (href.match(/\.(jpg|jpeg|png|gif|webm)/i)) {
              return react_1.default.createElement(My.Zoom, {
                wrapElement: "span"
              }, react_1.default.createElement(My.Image, {
                src: href
              }));
            }
            if (linkEmbed) {
              return react_1.default.createElement(My.Embed, {
                key: href,
                valueComponent: link_value_1.LinkValue,
                entity: linkEmbed
              });
            }
          }
          var linkRichEmbed = richEmbedByUrl.get(href);
          if (showEmbeds && linkRichEmbed && (0, lodash_1.isString)(firstChild) && firstChild.startsWith('LinkTitle:')) {
            return react_1.default.createElement(My.Embed, {
              key: linkRichEmbed.id,
              valueComponent: link_value_1.LinkValue,
              entity: linkRichEmbed
            });
          }
        }
        return react_1.default.createElement(My.Link, {
          inline: true,
          inverted: true,
          to: href
        }, children);
      }
    }
  };
  if (showEmbeds) {
    // add tag mappings for entities
    (0, lodash_1.each)((0, lodash_1.pickBy)(entities, function (defn) {
      return defn.canEmbed;
    }), function (defn) {
      overrides[defn.name] = {
        component: function (props) {
          // console.log(defn.name, props);
          var embed = embeds.find(function (embed) {
            return embed.__typename === defn.name && embed.slug === props.slug || embed.slug === props.id || embed.id === props.id;
          });
          return react_1.default.createElement(My.TagEmbed, {
            showDescription: false,
            imageSize: 56,
            entity: embed
          });
        }
      };
    });
  }
  return react_1.default.createElement(My.Container, {
    size: size,
    className: className
  }, react_1.default.createElement(markdown_to_jsx_1.default, {
    options: {
      overrides: overrides
    }
  }, text), showEmbeds && !!atEmbeds.length && react_1.default.createElement(My.Embeds, null, (0, lodash_1.filter)(atEmbeds, function (entity) {
    return !(0, lodash_1.includes)(entityTypeNameEmbedExclusions, entity.__typename);
  }).map(function (entity, index) {
    return react_1.default.createElement(My.Embed, __assign({}, props, {
      key: "".concat(index, "-").concat(entity.id),
      entity: entity
    }));
  })));
};
exports.Markdown = Markdown;
exports.Markdown.defaultProps = exports.MarkdownDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45;